import { sortBy } from 'lodash'

import { isSeries as isSeriesString } from './books'

/**
 * @typedef {import('../index').Line} Line
 */

/**
 * @param {number | 'series' | 'all' | undefined} bookId
 * @return {number | 'series' | 'all'}
 */
export const associateWithBroadestScope = (bookId) => bookId || 'series'

/**
 * @param {{ bookId: number | 'series' }} arg
 * @return {boolean}
 */
export const isSeries = ({ bookId }) => isSeriesString(bookId)

/**
 * @param {{ bookId: number | 'series' }} arg
 * @return {boolean}
 */
export const isNotSeries = ({ bookId }) => !isSeriesString(bookId)

/**
 * @param {number} lineId
 * @param {String} type
 * @return {['unknown'] | ['line', number, String]}
 */
export const lineFocusPath = (lineId, type) => {
  if (['title'].indexOf(type) !== -1) {
    return ['line', lineId, type]
  } else {
    return ['unknown']
  }
}

/**
 * @param {Array<Line>} lines
 * @return {Array<Line>}
 */
export const sortLinesWithPinnedFirst = (lines) => {
  return sortBy(lines, [
    ({ isPinned }) => (isPinned ? -1 : 1),
    ({ isPinned, pinnedPosition, position }) =>
      isPinned ? (pinnedPosition ?? position) : position,
  ])
}
